module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_frango-frito.9b441a45.png";